import { Component } from '@angular/core';

import { SmokeProvider } from '../../providers/smoke/smoke';

@Component({
  selector: 'smoke',
  templateUrl: 'smoke.html'
})
export class SmokeComponent {

  constructor(
    private smokeProvider: SmokeProvider
  ) {
  }

  test() {
    this.smokeProvider.activateSmoke();
  }
}




// WEBPACK FOOTER //
// ./src/components/smoke/smoke.ts